import { Dimensions } from "portal/utils/categoryCollection/image";
import { FilterBar } from "portal/components/filters/FilterBar";
import {
  INITIAL_PREDICTION_POINT_FILTERS,
  PredictionPointFilterChipSummary,
  PredictionPointFilters,
} from "portal/components/categoryCollectionProfile/filters/PredictionPointFilters";
import { LOCALSTORAGE_CATEGORY_COLLECTION_FILTER_BAR } from "portal/utils/localStorage";
import { RadioChipOption } from "portal/components/RadioChips";
import { ScrollableImageCategorizationOptions } from "portal/components/categoryCollectionProfile/ImageCategorizationOptions";
import { Typography } from "@mui/material";
import { UiPredictionPointFilters } from "portal/utils/categoryCollection/predictionPoints";
import { useTranslation } from "react-i18next";
import React, { FC, ReactNode, useState } from "react";
import SortIcon from "@mui/icons-material/Sort";

interface CategoryTemplateAllImagesProps {
  categoryOptions: RadioChipOption[];
  categorizationMap: Record<string, string>;
  dimensions: Dimensions;
  floatingAction?: ReactNode;
  scopeCustomerUuid?: string;
  onImageToggle: (predictionPointId: string) => void;
}

export const CategoryTemplateAllImages: FC<CategoryTemplateAllImagesProps> = ({
  categoryOptions,
  categorizationMap,
  dimensions,
  floatingAction,
  scopeCustomerUuid,
  onImageToggle,
}) => {
  const { t } = useTranslation();
  const [filters, setFilters] = useState<UiPredictionPointFilters>(
    INITIAL_PREDICTION_POINT_FILTERS
  );

  return (
    <>
      <div className="flex flex-col gap-2">
        <FilterBar
          localStorageKey={LOCALSTORAGE_CATEGORY_COLLECTION_FILTER_BAR}
          collapsedSummary={
            <PredictionPointFilterChipSummary filters={filters} />
          }
        >
          <PredictionPointFilters
            filters={filters}
            onChange={setFilters}
            scopeCustomerUuid={scopeCustomerUuid}
            showPlantProfileCategoryFilter
          />
        </FilterBar>
      </div>
      <div className="flex justify-end flex-wrap gap-6 mt-2">
        <div className="my-1 lg:my-2 flex gap-2 items-center justify-start">
          <SortIcon className="text-sm" />
          <Typography
            className="text-sm whitespace-nowrap"
            color="textSecondary"
          >
            {t("components.categoryCollectionProfile.images.sortedBy", {
              sortBy: t(
                "components.categoryCollectionProfile.images.sortBy.latest"
              ),
            })}
          </Typography>
        </div>
      </div>
      <ScrollableImageCategorizationOptions
        scopeCustomerUuid={scopeCustomerUuid}
        filters={filters}
        areFilterResultsIncomplete={false}
        dimensions={dimensions}
        categoryOptions={categoryOptions}
        categorizationMap={categorizationMap}
        onImageClick={onImageToggle}
        floatingAction={floatingAction}
        onClassify={(predictionPointId) => {
          onImageToggle(predictionPointId);
        }}
      />
    </>
  );
};
